import { formatCryptoAmount } from "../../utils/format";
import { FeedbackIcon, SuccessCelebrationIcon } from "../../icons";
import HelpModal from "../../../components/Modals/HelpModal";
import { useState } from "react";

const WithdrawComplete = ({
  activeTab = "Deposit",
  selectedAsset,
  selectedCryptoAccount,
  amount,
  onCheckAssets,
}) => {
  const [helpModalOpen, setHelpModalOpen] = useState(false);
  // const unitPrice = selectedAsset?.unit_price_usd ?? 1;

  return (
    <div className="flex h-full min-h-0 flex-col overflow-y-auto hide-scrollbar px-6 max-sm:pt-[20px] pt-4">
      <div className="flex flex-col items-center gap-2 pb-4">
        <SuccessCelebrationIcon className="-mt-10 -mb-10" />

        <div className="flex w-full flex-col items-center gap-4">
          <div className="flex flex-col items-center gap-2 text-center">
            <p className="text-base font-medium leading-7 text-text-primary">
              Successful
            </p>
            <p className="text-[28px] font-semibold leading-6 text-text-primary">
              {formatCryptoAmount(amount)} {selectedAsset?.currency_code}
            </p>
            <p className="text-xs font-medium leading-[21px] text-text-secondary">
              Your withdrawal request has been submitted and being processed.
            </p>
          </div>

          <button
            type="button"
            onClick={onCheckAssets}
            className="flex h-12 w-full items-center justify-center rounded-[10px] bg-[#4ab933] text-sm font-semibold leading-[21px] text-white custom-transition hover:bg-[#3fa82c]"
          >
            Check Status
          </button>
        </div>

        <div className="flex max-w-[432px] mx-auto w-full flex-col items-center gap-6 pt-6">
          <HelpModal
            HelpModalOpen={helpModalOpen}
            setHelpModalOpen={setHelpModalOpen}
            className={"w-[432px]"}
          >
            <button
              type="button"
              className="flex h-12 w-full items-center justify-between rounded-[10px] border border-divider px-4 py-2.5 custom-transition hover:bg-option-hover"
            >
              <span className="text-sm font-medium leading-[19.5px] text-text-primary">
                Provide Feedback
              </span>
              <FeedbackIcon />
            </button>
          </HelpModal>
        </div>
      </div>
    </div>
  );
};

export default WithdrawComplete;
